"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _services = require("@alycecom/services");

var _auth = require("./auth.actions");

var MAX_REQUEST_BUFFER_SIZE = 20;
var buffer = []; // Actions buffer which we need to execute after updating tokens.

var isLogoutInProgress = false;
var legacyCodeRequestIdentifier = 'REQUEST';
var rtkQueryRequestRegex = new RegExp("".concat(_services.API_BASE_REDUCER_PATH, "\\w+/execute\\w+/pending"));
var excludedActions = [_auth.refreshTokenRequest.getType(), _auth.logoutRequest.getType()];
var isNotExcludedAction = (0, _ramda.pipe)((0, _ramda.flip)(_ramda.includes)(excludedActions), _ramda.not);

var isUnauthorized = function isUnauthorized(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return (type === null || type === void 0 ? void 0 : type.includes('HANDLE_SERVER_ERROR')) && payload && payload.status === 401;
};

var needTokenUpdate = function needTokenUpdate(_ref2, settings) {
  var _type$match;

  var type = _ref2.type,
      payload = _ref2.payload;

  if (isUnauthorized({
    type,
    payload
  })) {
    return true;
  }

  var isLegacyRequestAction = type === null || type === void 0 ? void 0 : type.includes(legacyCodeRequestIdentifier);
  var isRtkQueryRequestAction = (type === null || type === void 0 ? void 0 : (_type$match = type.match(rtkQueryRequestRegex)) === null || _type$match === void 0 ? void 0 : _type$match.length) > 0;
  var isTokenExpired = settings.tokenService.isExpired();
  return (isLegacyRequestAction || isRtkQueryRequestAction) && isNotExcludedAction(type) && isTokenExpired;
};

var createAuthMiddleware = function createAuthMiddleware(settings) {
  return function (_ref3) {
    var dispatch = _ref3.dispatch,
        getState = _ref3.getState;
    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;
        var shouldDoLogout = buffer.length > MAX_REQUEST_BUFFER_SIZE && isNotExcludedAction(type);
        var shouldUpdateToken = needTokenUpdate(action, settings);

        var shouldDispatchActions = type === _auth.refreshTokenSuccess.getType();

        if (isLogoutInProgress) {
          return next(action);
        }

        if (shouldDoLogout) {
          isLogoutInProgress = true;
          dispatch((0, _auth.logoutRequest)(settings.logoutUrl));
        } else if (shouldUpdateToken) {
          if (!isUnauthorized({
            type,
            payload
          })) {
            buffer.push(action);
          }

          var state = getState();

          if (!state.auth.accessTokenIsRequesting) {
            dispatch((0, _auth.refreshTokenRequest)());
          }
        } else if (shouldDispatchActions) {
          buffer.forEach(function (actionItem) {
            dispatch(actionItem);
          });
          buffer = [];
        }

        return next(action);
      };
    };
  };
};

var _default = createAuthMiddleware;
exports.default = _default;